import React, { useEffect } from 'react';

import { ContainerHeader } from '~components';
import { faHandHoldingHeart } from '~components/icon';

import { setTitle } from '~main/actions/login';

import { BudgetDashboard } from './BudgetDashboard';

const DashboardContainer: React.FC = () => {
  useEffect(() => {
    setTitle('Support At Home — Dashboard');
  }, []);

  return (
    <div className="p-2">
      <ContainerHeader icon={faHandHoldingHeart} iconSize="1x" className="info" dataCy="support-at-home-header">
        Support At Home — Dashboard
      </ContainerHeader>
      <div className="sah-container">
        <BudgetDashboard />
      </div>
    </div>
  );
};

export default DashboardContainer;
